export interface NewLineManagerAssignment {
  readonly currentLineManager: string
  readonly endDate: string
  readonly startingDate: string
  readonly temporaryDeputy: string
  readonly ticketUrl: string
}

export interface LineManagerAssignment extends NewLineManagerAssignment {
  readonly id: string
  readonly submittedAt: string
}

export const localtext = {
  ApprovalConfirmationAction: "Confirmed — Submit",
  ApprovalConfirmationDescription: (currentLineManager: string, ticketUrl: string) => `Please confirm that ticket ${ticketUrl} contains the approval from ${currentLineManager} as an attachment or comment.`,
  ApprovalConfirmationTitle: "Line Manager Approval Required",
  ApprovalConfirmationWarning: "Before proceeding, ensure the current line manager's approval is attached or referenced in the ticket comments.",
  ApprovalConfirmationWarningTitle: "Confirm approval is on record",
  CoverageDuration: (days: number) => `${days} day${days === 1 ? "" : "s"} coverage`,
  CurrentLineManager: "Current Line Manager",
  EndDate: "End Date",
  ErrorEndDateAfterStart: "End date must be after the starting date",
  ErrorEndDateMaximum: "End date must be no more than 12 months from today",
  ErrorRequired: "This field is required",
  ErrorStartingDateToday: "Starting date cannot be before today",
  PlaceholderEmployee: "Employee ID or name",
  PlaceholderEndDate: "End Date",
  PlaceholderStartDate: "Start Date",
  PlaceholderTicketUrl: "https://jira.example.com/browse/CDHX-12345",
  StartingDate: "Starting Date",
  SubmitAssignment: "Submit Assignment",
  TemporaryDeputy: "Temporary Deputy",
  TicketUrl: "Ticket URL",
  Title: "Assignment Details",
} as const

export const MAX_ASSIGNMENT_YEARS = 1
